/**
 * [予定進捗推移] 期間の一覧
 */
export const planProgressTransitionDateRangeDateRanges = [
  '前月',
  '今月',
  'カスタム',
] as const;
